import { render } from "./CreateBar.vue?vue&type=template&id=d6da44a4"
import script from "./CreateBar.vue?vue&type=script&lang=js"
export * from "./CreateBar.vue?vue&type=script&lang=js"

import "./CreateBar.vue?vue&type=style&index=0&id=d6da44a4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__